import { isDefined } from "@omni/utils/helper.utils";
import {
    ControllerFieldState,
    ControllerRenderProps,
    FieldValues,
    Path,
    UseFormStateReturn
} from "react-hook-form";

import { memoizeObject } from "@/utils/memoize";

export const calculateFieldState = <TFieldValues extends FieldValues>(
    fieldState: ControllerFieldState,
    formState: UseFormStateReturn<TFieldValues>
) => {
    return memoizeObject({
        isInvalid:
            (formState.isSubmitted || fieldState.isTouched) &&
            !!fieldState.error,
        isValid:
            (formState.isSubmitted || fieldState.isTouched) && !fieldState.error
    });
};

export const getFieldValue = <TFieldValues extends FieldValues, TDefaultValue>(
    field: ControllerRenderProps<
        TFieldValues,
        Extract<Path<TFieldValues>, string>
    >,
    loading: boolean,
    defaultValue: TDefaultValue
) => {
    if (isDefined(field.value)) {
        return field.value;
    } else if (loading) {
        return defaultValue;
    } else {
        return undefined;
    }
};
